// extracted by mini-css-extract-plugin
export default {"button":"gEp+5","link":"d43zr","mobileLink":"may+z","description":"_1temU","expanded":"Fp2PK"};